import React from 'react';
import { Box, Stack, Typography, SxProps, Theme } from '@mui/material';
import { tokens } from '../../theme';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  /** Co zrobic dalej — jedno zdanie. */
  description?: React.ReactNode;
  actions?: React.ReactNode;
  /** Mniejsza wersja do wnetrza kart. */
  compact?: boolean;
  sx?: SxProps<Theme>;
}

/** Pusty ekran, ktory podpowiada nastepny krok. */
export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, actions, compact, sx }) => (
  <Box sx={{ textAlign: 'center', px: 2, py: compact ? 3 : { xs: 5, md: 7 }, ...((sx as object) || {}) }}>
    {icon && (
      <Box
        sx={{
          width: compact ? 44 : 56,
          height: compact ? 44 : 56,
          mx: 'auto',
          mb: 1.5,
          borderRadius: '50%',
          bgcolor: tokens.plumSoft,
          color: tokens.plum,
          display: 'grid',
          placeItems: 'center',
          '& .MuiSvgIcon-root': { fontSize: compact ? 22 : 26 },
        }}
      >
        {icon}
      </Box>
    )}
    <Typography component="h3" sx={{ fontSize: compact ? '0.9375rem' : '1.0625rem', fontWeight: 700 }}>{title}</Typography>
    {description && (
      <Typography component="div" sx={{ mt: 0.75, mx: 'auto', maxWidth: '44ch', color: tokens.inkSoft, fontSize: compact ? '0.875rem' : '0.9375rem' }}>
        {description}
      </Typography>
    )}
    {actions && (
      <Stack direction="row" gap={1} justifyContent="center" flexWrap="wrap" sx={{ mt: 2.25 }}>
        {actions}
      </Stack>
    )}
  </Box>
);

export default EmptyState;
